"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return CustomUrl;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let CustomUrl = class CustomUrl {
    static async get(_params, _ncMeta = _Noco.default.ncMeta) {
        return {};
    }
    static async getCustomUrlByCustomPath(_customPath, _ncMeta = _Noco.default.ncMeta) {
        return;
    }
    static async insert(_customUrl, _ncMeta = _Noco.default.ncMeta) {
        return {};
    }
    static async list(_params, _ncMeta = _Noco.default.ncMeta) {
        return [];
    }
    static async update(_id, _customUrl, _ncMeta = _Noco.default.ncMeta) {
        return {};
    }
    static async checkAvailability(_params, _ncMeta = _Noco.default.ncMeta) {
        return false;
    }
    static async delete(_customUrl, _ncMeta = _Noco.default.ncMeta) {}
    static async bulkDelete(_params, _ncMeta = _Noco.default.ncMeta) {}
    constructor(customUrl){
        Object.assign(this, customUrl);
    }
};
